// extracted by mini-css-extract-plugin
export default {"container":"preloader_component_container__Q5HoM"};